export const SidebarSize = {
  SMALL: "small",
  LARGE: "large",
  MEDIUM: "medium",
};

export const SidebarPosition = {
  LEFT: "left",
  RIGHT: "right",
};
